var Backbone = require('backbone');
var _ = require('underscore/underscore');

var Base = require('front/components/Base/Base');

require('./SellBlockInfo.less');

module.exports = Base.extend({
    template: require('./SellBlockInfo.jinja'),

    el: '.SellBlockInfo',

    events: {
    },

    initialize: function (options) {
        Base.prototype.initialize.call(this, options);

        //Radio stylization
        $('.SellBlockInfo-descrSwitcherLabel input[type=radio]').each(function () {
            if ($(this).is(':checked')) {
                $(this)
                    .closest('label')
                    .addClass('SellBlockInfo-descrSwitcherLabel--checked');
            }

            $(this).on('change', function () {
                var nm = $(this).attr('name');
                $('label input[name=' + nm + ']').each(function () {
                    if ($(this).is(':checked')) {
                        $(this)
                            .closest('label')
                            .addClass('SellBlockInfo-descrSwitcherLabel--checked');
                    } else {
                        $(this)
                            .closest('label')
                            .removeClass('SellBlockInfo-descrSwitcherLabel--checked');
                    }
                });
            });
        });

        //Switcher func
        $('.SellBlockInfo-descrSwitcher input[type=radio]').each(function () {
            var ths = $(this);
            var switcherWrap = ths.closest('.SellBlockInfo-descr');

            ths.on('change', function () {
                var switcherVal = ths.val();

                switcherWrap
                    .find('.SellBlockInfo-descrSwitcherSwitch--active')
                    .removeClass('SellBlockInfo-descrSwitcherSwitch--active');
                switcherWrap
                    .find('.SellBlockInfo-descrSwitcherSwitch[data-switch=' + switcherVal + ']')
                    .addClass('SellBlockInfo-descrSwitcherSwitch--active');
            });
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SellBlockInfo/SellBlockInfo.js
// module id = 55
// module chunks = 0